// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header-container":"Header_header-container__L8Rlc","logo":"Header_logo__UsziS"};